import React, { FC } from 'react';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import Colours from '../../../design-system/colours';
import OvButton from './OvButton';

interface OvOrderEditButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

const OvOrderEditButton: FC<OvOrderEditButtonProps> = ({
  onClick,
  disabled = false,
  label,
}) => {
  const { t } = useTranslation();

  return (
    <StyledButton disabled={disabled} onClick={onClick} aria-label={label}>
      <StyledEditIcon />
      {t('common.actions.edit')}
    </StyledButton>
  );
};

export default OvOrderEditButton;

const StyledButton = styled(OvButton)`
  && {
    padding: 0 0.5rem;
    background: transparent;
    background-color: transparent;
    color: ${Colours.OV_BASE};
    max-height: 1.5rem;
    text-transform: none;

    &:hover {
      background-color: ${Colours.OV_WHITE_HOVER};
    }
  }
`;

const StyledEditIcon = styled(EditIcon)`
  && {
    margin-right: 0.5rem;
    font-size: 1rem;
  }
`;
